import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { FaWhatsapp, FaPhoneAlt, FaBed, FaBath, FaDoorOpen } from "react-icons/fa";
import BottomNav from "../../component/BottomNav";
import axios from "axios";
import { API_URL } from "../../common/constant";
import Loader from "../loader/Loader";

const SellPropertyDetails = () => {
    const { id } = useParams();
    const phoneNumber = "8318150076";
    const [property, setProperty] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selectedImage, setSelectedImage] = useState("");

    useEffect(() => {
        const fetchPropertyDetails = async () => {
            try {
                const response = await axios.get(`${API_URL}/api/property/get-sell-property/${id}`);
                console.log(response)
                setProperty(response.data.sellProperty);

                setSelectedImage(response.data?.sellProperty?.mainImage);
            } catch (error) {
                setError("Failed to fetch property details");
                console.error("Error fetching property details:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchPropertyDetails();
    }, [id]);

    if (loading) return <Loader />;
    if (error) return <p className="text-center text-xl mt-10 text-red-500">{error}</p>;

    console.log(`${API_URL}/uploads/properties/${id}/${selectedImage}`)

    return (
        <div className="bg-gray-50 min-h-screen p-4 md:p-6">
            <div className="rounded-lg p-4">
                <div className="flex flex-col lg:flex-row">
                    <div className="lg:w-1/2">
                        <img src={`${API_URL}/uploads/properties/${id}/${selectedImage}`} alt="Property" className="w-full h-64 md:h-96 rounded-lg object-cover" />
                        <div className="flex space-x-4 mt-4 overflow-x-auto">
                            {property.otherImages?.map((image, index) => (
                                <img
                                    key={index}
                                    src={`${API_URL}/uploads/properties/${id}/${image}`}
                                    alt="Property"
                                    className={`w-16 h-16 md:w-20 md:h-20 object-cover rounded-lg cursor-pointer ${selectedImage === image ? "border-4 border-[#54BD95]" : "border"}`}
                                    onClick={() => setSelectedImage(image)}
                                />
                            ))}
                        </div>
                        <div className="grid grid-cols-2 gap-4 mt-4">
                            <div className="p-2 rounded-lg">
                                <p>Price</p>
                                <p className="font-semibold">{property.propertyPrice}</p>
                            </div>
                            <div className="p-2 rounded-lg">
                                <p>Furnishing Status</p>
                                <p className="font-semibold">{property.furnishedType}</p>
                            </div>
                            <div className="p-2 rounded-lg">
                                <p>BHK</p>
                                <p className="font-semibold">{property.bhk}</p>
                            </div>
                            <div className="p-2 rounded-lg">
                                <p>Area</p>
                                <p className="font-semibold">{property.area}</p>
                            </div>
                        </div>
                    </div>
                    <div className="lg:w-1/2 lg:pl-6 mt-6 lg:mt-0">
                        <h1 className="text-2xl font-bold text-gray-800">{`${property.bhk} For Sale In Lucknow`}</h1>
                        <p>{property.address}</p>
                        <p className="text-lg font-semibold text-[#54BD95] mt-2">{`Price ₹ ${property.propertyPrice}`}</p>
                        <div className="grid grid-cols-2 gap-4 mt-14">
                            <div className="flex items-center space-x-2 text-gray-700">
                                <FaBed size={20} className="text-[#54BD95]" /> <span>{property.bed} Bedrooms</span>
                            </div>
                            <div className="flex items-center space-x-2 text-gray-700">
                                <FaBath size={20} className="text-[#54BD95]" /> <span>{property.bathroom} Bathrooms</span>
                            </div>
                            <div className="flex items-center space-x-2 text-gray-700">
                                <FaDoorOpen size={20} className="text-[#54BD95]" /> <span>{property.balcony} Balcony</span>
                            </div>
                        </div>
                        <div className="mt-14">
                            <h2 className="text-lg font-semibold text-gray-800">Description</h2>
                            <p className="text-gray-700 mt-2">{property.description}</p>
                        </div>
                        <div className="mt-28">
                            <h3 className="text-lg font-semibold text-gray-800">Get in Touch</h3>
                            <div className="flex flex-col items-center sm:w-80 mt-4">
                                <a href={`tel:${phoneNumber}`} className="flex items-center justify-center w-full bg-[#54BD95] text-white px-4 py-3 rounded-lg text-md hover:bg-[#45a282] transition-all duration-200">
                                    <FaPhoneAlt className="text-white mr-2" size={18} />
                                    <span>Contact Us</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="bg-white shadow-md rounded-lg p-6 mt-6">
                    <h2 className="text-xl font-semibold text-gray-800 mb-4">Location</h2>
                    <iframe
                        src={property.mapLocation || "https://www.google.com/maps?q=Lucknow&output=embed"}
                        width="100%"
                        height="350"
                        allowFullScreen=""
                        loading="lazy"
                        title="Map"
                        className="rounded-lg w-full cursor-pointer"
                    ></iframe>

                </div>
            </div>
            <BottomNav />
        </div>
    );
};

export default SellPropertyDetails;